import React, {useEffect, useState} from "react";

import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import problemIcon from "../../../../../resources/images/problem-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";

export const RootCauseOne = ({
                                 context,
                                 setSpinnerText,
                                 showToaster,
                                 setContext,
                                 navigateTo,
                                 navigateBack,
                                 toolTipsEnabled
                             }) => {

    const [name, setName] = useState(null);
    const [description, setDescription] = useState(null);

    useEffect(() => {
        if (context.viewMode) {
            if (!context.copyOfRootCauseScreen) {
                const copyOfRootCauseScreen = JSON.stringify(context.rootCauseScreen);
                setContext((prevState) => ({
                    ...prevState,
                    copyOfRootCauseScreen,
                }));
            }
        }
    }, [])

    useEffect(() => {
        if (context.rootCauseScreen) {
            if (context.rootCauseScreen.name) {
                setName(context.rootCauseScreen.name);
            }

            if (context.rootCauseScreen.description) {
                setDescription(context.rootCauseScreen.description);
            }
        }
    }, [context]);

    const handleNextClick = () => {
        setContext((prevState) => ({
            ...prevState,
            rootCauseScreen: {
                ...prevState.rootCauseScreen,
                name,
                description,
            }
        }))
        navigateTo("rootCauseTwo");
    }

    const isButtonDisabled = () => {
        return (!name || name === "" || !description || description === "");
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={problemIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.problemScreen.title}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="input-container">
                        <div>
                            <label>Root Cause:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"rootc123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Root Cause:"}/>}
                        </div>
                        <input data-testid="root-cause" className="text-input" disabled={!context.editMode} onChange={({target}) => {
                            setName(target.value)
                        }}
                               defaultValue={name ? name : null}/>
                    </div>
                    <div className="input-container">
                        <div>
                            <label>Root Cause Description:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"rootcdesc123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Root Cause Description:"}/>}
                        </div>
                        <textarea data-testid="root-cause-description" disabled={!context.editMode} onChange={({target}) => {
                            setDescription(target.value)
                        }} defaultValue={description ? description : null}/>
                    </div>
                    {context.viewMode && context.rootCauseScreen && context.rootCauseScreen.externalReference &&
                    <CommentToolTip contextName={"Cause"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.rootCauseScreen.externalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
